"use client"

import { StoreCart } from "@/types/store"
import { usePathname } from "next/navigation"
import { useMemo } from "react"
import CartDropdown from "../cart-dropdown"

export default function CartButtonClient({
    cart,
    customer
}: {
    cart: StoreCart | null
    customer?: any
}) {
    const pathname = usePathname()

    // Skip using server-fetched cart on cart/checkout pages to avoid duplicate API calls
    // Those pages handle their own cart fetching and price change detection
    // This prevents the cart dropdown from initializing with stale data that might trigger
    // price change detection conflicts with the cart/checkout pages
    const isOnCartOrCheckoutPage = useMemo(
        () => pathname?.includes("/cart") || pathname?.includes("/checkout"),
        [pathname]
    )

    // Pass null cart if we're on cart/checkout pages
    // This prevents the cart dropdown from using the server-fetched cart
    // and allows those pages to manage their own cart state
    const cartToUse = isOnCartOrCheckoutPage ? null : cart

    return <CartDropdown cart={cartToUse} customer={customer} />
}

